import { CANAIS_VENDA_TODOS } from "@/utils/canais-venda";

export const NOME_INTERNO_HELP =
  "O nome interno é a chave estável da característica na integração (ERP/mensageria). Evite alterar depois de já estar em uso.";

export const CANAIS_VENDA_HELP =
  "Todos os canais podem ser desmarcados. Para deixar a característica visível só no LifeGrowth, desmarque Site, App, Integração, Venda+ e Vendedor.";

export const TIPOS_CARACTERISTICA_CLIENTE = [
  { text: "Texto", value: "string" },
  { text: "Booleano", value: "boolean" },
  { text: "Intervalo de Valores", value: "array" },
  { text: "Documento", value: "documento" }
];

export function rotuloTipoCaracteristica(tipo) {
  const found = TIPOS_CARACTERISTICA_CLIENTE.find(item => item.value === tipo);
  return found ? found.text : tipo || "";
}

const CANAIS_PERMITIDOS = new Set(CANAIS_VENDA_TODOS);

function uniqueCanaisValidos(input) {
  const selected = Array.isArray(input) ? input : [];
  const unique = [];
  selected.forEach(canal => {
    if (CANAIS_PERMITIDOS.has(canal) && !unique.includes(canal)) {
      unique.push(canal);
    }
  });
  return unique;
}

export function normalizeCanaisVendaFromApi(canaisFromApi) {
  const unique = uniqueCanaisValidos(canaisFromApi);
  return unique.length ? unique : [...CANAIS_VENDA_TODOS];
}

export function buildCanaisVendaPayload(selected) {
  return uniqueCanaisValidos(selected);
}

export function resolveExibirNoFormulario(value) {
  return value !== false;
}

export function createDefaultCaracteristicaForm() {
  return {
    nome: "",
    nome_interno: "",
    permite_alteracao_erp: true,
    obrigatorio: false,
    tipo: "string",
    itens_caracteristica: [],
    multiplo: false,
    canais_venda: [...CANAIS_VENDA_TODOS],
    exibir_no_formulario: true
  };
}

export function mapCaracteristicaFromApi(resp) {
  const loaded = resp || {};
  return {
    ...createDefaultCaracteristicaForm(),
    ...loaded,
    canais_venda: normalizeCanaisVendaFromApi(loaded.canais_venda),
    exibir_no_formulario: resolveExibirNoFormulario(loaded.exibir_no_formulario)
  };
}

export function buildCaracteristicaSubmitPayload(form, isArray) {
  const payload = { ...(form || createDefaultCaracteristicaForm()) };
  payload.canais_venda = buildCanaisVendaPayload(payload.canais_venda);
  payload.exibir_no_formulario = resolveExibirNoFormulario(
    payload.exibir_no_formulario
  );
  if (!isArray) {
    payload.itens_caracteristica = [];
    payload.multiplo = false;
  }
  if (payload.tipo === "documento") {
    delete payload.permite_alteracao_erp;
  }
  return payload;
}

export function canSubmitCaracteristica(form) {
  if (!form || !form.nome || !form.nome_interno) {
    return false;
  }
  return buildCanaisVendaPayload(form.canais_venda).length > 0;
}
